import { render, staticRenderFns } from "./PremiumFileComponent.vue?vue&type=template&id=7eed81a4&scoped=true&"
import script from "./PremiumFileComponent.vue?vue&type=script&lang=js&"
export * from "./PremiumFileComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eed81a4",
  null
  
)

export default component.exports